// import Image from 'next/image'
import { Container, Row, Col } from 'reactstrap';
import classNames from 'classnames';
import { Benefit } from './benefit';
import { Section } from '../Sections';
import { Icon } from '../Icon';
import { RichText } from 'prismic-reactjs';

interface Props {
  title: string;
  backgroundColor: string;
  benefits: Array<Benefit>;
  hasBorder?: boolean;
}

interface Benefit {
  benefits_section__icons__icon: any;
  benefits_section__icons__title: any;
  icon: any;
  title: string;
}

export const BenefitsSection: React.FunctionComponent<Props> = (props) => {
  const { title, benefits, backgroundColor, hasBorder } = props;

  const benefitSectionClass = classNames('benefits-section', {
    ['color--background--green-light']: backgroundColor === 'green-light',
    ['color--background--blue-light']: backgroundColor === 'blue-light',
    ['color--background--brown-light']: backgroundColor === 'brown-light',
    ['benefits-section--border']: hasBorder,
  });

  return (
    <div className={benefitSectionClass}>
      <Section hasBottom={false}>
        <Container fluid>
          <Row>
            <Col size={6} md={4}>
              <h2 className="font--xl font--primary">{title}</h2>
            </Col>
            <Col size={6} md={8}>
              <Row>
                {benefits &&
                  benefits.map((benefit, key) => (
                    <Benefit
                      key={key}
                      icon={
                        <Icon type={benefit.benefits_section__icons__icon} />
                      }
                      title={RichText.asText(
                        benefit.benefits_section__icons__title
                      )}
                    />
                  ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </Section>
    </div>
  );
};
